import { render, staticRenderFns } from "./cModalPreview.vue?vue&type=template&id=50874e95"
import script from "./cModalPreview.vue?vue&type=script&lang=js"
export * from "./cModalPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports